<template>
<div>
	<form action="">
                <div class="modal-card">
 
                    <section class="modal-card-body">
                        <b-field label="Password">
                            <b-input type="password"
                                password-reveal>
                            </b-input>
                        </b-field>
                        </section>
                        <b-button
                            label="Submit"
                            type="is-primary"
                            :loading="loading"
							@click="submitPassword"/>
                    </footer>
                 
                </div>
            </form>

             </div>
</template>

<script>
export default {
  name: 'CreatePublicLinkModalComponent',
 	props: ['charts'],
	data() {
		return {
			loading: false,
			title: "",
            expiry_in_days: 60,
            public_link:"",
            password_enabled:false,
            password:"",
             charts_data: this.charts,
             apiurl: this.$store.getters.apiurl,
		}
	},
	methods: {
        submitPassword(){
                this.$parent.get_graph_data_for_link(this.password)
                this.$emit('close')
      
		
        }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control.has-icons-left .icon,
.control.has-icons-right .icon {
  pointer-events: auto !important;
}
</style>

